<template>
  <div class="product" id="product">
    <v-app>
      <v-app-bar
      app
      color='primary'
      dark
      height="564"
      absolute
      >
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <!-- 大标题 -->
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col  cols="12">
                <h1 class="first_title white--text">
                  大数据平台
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_dashujv.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <v-app-bar
          :fixed='second_bar_fixed'
          prominent
          height="64"
          color="white"
          :flat='!second_bar_fixed'
        >
          <v-tabs v-model="second_active_tab" centered>
            <v-tab v-for="tab in contentList" :key='tab.index'  @click="goTo(tab.index)" class="body_text">{{tab.firstTitle}}</v-tab>
          </v-tabs>
        </v-app-bar>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <!-- 数据清洗 -->
              <BoxTitle :firstTitle="contentList[0].firstTitle" :desc="contentList[0].desc" :index="contentList[0].index"></BoxTitle>
              <BoxLr :data='contentList[0].children[0]' :left_img="true"></BoxLr>
              <BoxSpaceAround :data='contentList[0].children[1]' :dark="false" :img_top="false" img_size='60%' card_width="12rem" card_height="16rem" background="rgb(212, 217, 223)"></BoxSpaceAround>
              <BoxLr :data='contentList[0].children[2]' :left_img="false"></BoxLr>
              <!-- 数据仓库 -->
              <BoxTitle :firstTitle="contentList[1].firstTitle" :desc="contentList[1].desc" :index="contentList[1].index" :dark="true"></BoxTitle>
              <BoxLr :data='contentList[1].children[0]' :left_img="true" :dark="true"></BoxLr>
              <v-row justify="center" align="center" style="background-color:var(--iconColor)">
                <h1 class="text-justify font-weight-thin mb-4 third_title white--text">
                  广泛应用于
                </h1>
              </v-row>
              <v-row justify="space-around" align="center" style="background-color:var(--iconColor);text-align:center">
                <div style="width:250px">
                  <v-list dense color="rgba(1,1,1,0)">
                    <v-list-item v-for="i in ['● 数据挖掘&emsp;&emsp;','● 人工智能&emsp;&emsp;','● 机器学习&emsp;&emsp;']" :key="i">
                      <v-list-item-content>
                        <v-list-item-title>
                          <p v-html="i" class="body_text white--text" style="line-height:1.5"></p>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
                <div style="width:250px">
                  <v-list dense color="rgba(1,1,1,0)">
                    <v-list-item v-for="i in ['● 风险控制&emsp;&emsp;','● 无人驾驶&emsp;&emsp;','● 数据分析&emsp;&emsp;']" :key="i">
                      <v-list-item-content>
                        <v-list-item-title>
                          <p v-html="i" class="body_text white--text" style="line-height:1.5"></p>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
                <div style="width:250px">
                  <v-list dense color="rgba(1,1,1,0)">
                    <v-list-item v-for="i in ['● 广告智能投放','● 数据精准运营', '● 商业智能&emsp;&emsp;']" :key="i">
                      <v-list-item-content>
                        <v-list-item-title>
                          <p v-html="i" class="body_text white--text" style="line-height:1.5"></p>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-row>
              <!-- 数据分析 -->
              <BoxTitle :firstTitle="contentList[2].firstTitle" :desc="contentList[2].desc" :index="contentList[2].index"></BoxTitle>
              <BoxLr :data='contentList[2].children[0]' :left_img="true"></BoxLr>
              <BoxLr :data='contentList[2].children[1]' :left_img="false"></BoxLr>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn v-show="!floatHidden" color="primary"  fixed  bottom right fab @click="goTo(0)">
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxLr from '../components/box-lr.vue'
import BoxSpaceAround from '../components/box-space-around.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'products',

  components: {
    FootContent,
    FirstNavbar,
    BoxLr,
    BoxSpaceAround,
    BoxTitle
  },

  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 是否显示totop按钮
    goto: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 2,
    // 二级导航选项卡
    second_active_tab: 0,
    // 二级导航是否冻结
    second_bar_fixed: false,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    items: [
      {
        icon: 'mdi-inbox',
        text: 'Inbox'
      },
      {
        icon: 'mdi-star',
        text: 'Star'
      },
      {
        icon: 'mdi-send',
        text: 'Send'
      },
      {
        icon: 'mdi-email-open',
        text: 'Drafts'
      }
    ],
    model: 1,
    // 内容数据
    contentList: [{
      index: 1,
      firstTitle: '数据清洗',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'product_sjck.gif',
        content: {
          title: '',
          body: '动态可配置大数据清洗平台通过数据抽取、整合、质检、清洗、加载完成脏数据的检测清洗，实现数据的准确性、一致性、有效性，为大数据分析提供高质量、标准化数据',
          btn: '',
          list: []
        }
      }, {
        index: 2,
        src: 'product_sjck.png',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: 'product_icon1.png',
            title: '',
            subtitle: '',
            body: '平台利用数据仓库技术，可实现海量数据的存储和计算'
          }, {
            index: 2,
            src: 'product_icon2.png',
            title: '',
            subtitle: '',
            body: '兼容多种数据来源、数据格式'
          }, {
            index: 3,
            src: 'product_icon3.png',
            title: '',
            subtitle: '',
            body: '一键选择，人工操作少，达到高度自动化清洗操作'
          }, {
            index: 4,
            src: 'product_icon4.png',
            title: '',
            subtitle: '',
            body: '检测、清洗过程动态展示，显示更直观'
          }, {
            index: 5,
            src: 'product_icon5.png',
            title: '',
            subtitle: '',
            body: '适用企业、科研机构、教育机构、医疗机构等多行业'
          }]
        }
      }, {
        index: 3,
        src: '大数据平台数据清洗.jpg',
        title: '',
        content: {
          title: '',
          src: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '助力模型训练',
            subtitle: '',
            body: '为模型开发提供高质量的训练数据，输出更高精度的模型'
          }, {
            index: 2,
            src: '',
            title: '指导决策',
            subtitle: '',
            body: '数据清洗是提高数据质量的重要方法，其有助于大数据系统做出正确决策'
          }]
        }
      }]

    }, {
      index: 2,
      firstTitle: '数据仓库',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '大数据平台数据仓库.jpg',
        content: {
          title: '',
          body: '数据仓库基础平台将企业、系统或行业范围内数据进行整合，分类、分级存储，解决跨部门、跨领域、跨行业数据集成的壁垒，提升数据访问的便捷度和透明度',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '方便快速获取数据',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '数据经过清洗，数据质量高',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '分析结果图表化展示，更直观',
            subtitle: '',
            body: ''
          }, {
            index: 4,
            src: '',
            title: '适用于多种主题的应用场景',
            subtitle: '',
            body: ''
          }]
        }
      }, {
        index: 2,
        src: '',
        content: {
          title: '广泛应用于',
          body: '',
          list: [{
            index: 1,
            src: '数据挖掘.jpg',
            title: '数据挖掘',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '人工智能.jpg',
            title: '人工智能',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '机器学习.jpg',
            title: '机器学习',
            subtitle: '',
            body: ''
          }, {
            index: 4,
            src: '风险控制.jpg',
            title: '风险控制',
            subtitle: '',
            body: ''
          }, {
            index: 5,
            src: '无人驾驶.jpg',
            title: '无人驾驶',
            subtitle: '',
            body: ''
          }, {
            index: 6,
            src: '数据运营.jpg',
            title: '数据精准运营',
            subtitle: '',
            body: ''
          }, {
            index: 7,
            src: '广告投放.jpg',
            title: '广告智能投放',
            subtitle: '',
            body: ''
          }, {
            index: 8,
            src: '数据分析.jpg',
            title: '数据分析',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 3,
      firstTitle: '数据分析',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '数据分析.jpg',
        title: '',
        content: {
          title: '',
          src: '',
          body: '嘉旭福美数据分析业务整合用户行为、业务经营等多种数据源，覆盖全场景的业务分析与用户（群）洞察，为企业及政府机关中的不同角色提供实时、多维度的数据分析和智能决策方案',
          btn: '',
          list: []
        }
      }, {
        index: 2,
        src: '大数据平台数据分析2.jpg',
        title: '',
        content: {
          title: '城市空气质量预测平台',
          src: '',
          body: '城市空气质量预测平台运用随机森林算法对大气监测站数据、气象数据建模分析，实现空气质量预测、等级分类、预警，为用户出行和环保决策提供数据支持',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '良好的模型预测性能',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '可视化展示，直观形象',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '可实现不同时间尺度预测',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }]
  }),
  mounted () {
    this.goTo(0)
    // // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.contentList.forEach((val, index, arry) => {
      this.contentList[index].scrollTop = this.$el.querySelector('#part' + this.contentList[index].index).offsetTop + 564
    })
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },

  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.second_bar_fixed = true
        this.gotop = true
      } else {
        this.second_bar_fixed = false
        this.barColor = 'rgba(63, 81, 181,0)'
        this.gotop = false
      }
      if (scrollTop < this.contentList[0].scrollTop) {
        this.second_active_tab = 0
        this.floatHidden = false
      } else if (scrollTop > this.contentList[this.contentList.length - 1].scrollTop) {
        this.second_active_tab = this.contentList.length - 1
        this.floatHidden = false
      } else {
        for (var i = 1; i < this.contentList.length; i++) {
          if (i <= this.contentList.length) {
            if (scrollTop >= this.contentList[i - 1].scrollTop & scrollTop < this.contentList[i].scrollTop) {
              this.second_active_tab = i - 1
              this.floatHidden = false
            }
          }
        }
      }
    },
    goTo (index) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      // document.documentElement.scrollTop = anchor.offsetTop + 500
      if (index === 0) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
        document.documentElement.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
      }
    }
  }

}
</script>

<style>

</style>
